import React from 'react';
import Translate from '@spordle/intl-elements';
import { useIntl } from 'react-intl';

import { SchemaStatsHeader, SchemaStatsRow } from '../SchemaStats';
import Team from '../Team';

export const TableHeader = ({ isMobile, properties, disableSorting, querySort, queryOrder, handleSorting }) => {
  const { formatMessage } = useIntl();
  const className = isMobile ? 'small font-weight-bold text-center': 'text-center'
  const teamClassName = isMobile ? 'small font-weight-bold' : ''

  return <tr>
    <th className={className} title={formatMessage({ id: 'common.lang.rank' })}><Translate id="common.lang.rank.abbr" /></th>
    <th className={teamClassName}><Translate id="common.lang.team" /></th>
    <SchemaStatsHeader
      properties={properties}
      className={className}
      disableSorting={disableSorting}
      querySort={querySort}
      queryOrder={queryOrder}
      handleSorting={handleSorting}
    />
  </tr>
}

export const TableRow = ({ isMobile, stats, index, highlight, properties }) => {
  const trClassName = highlight ? 'highlight table-success' : '';
  const indexClassName = 'align-middle font-weight-semibold text-large text-center';
  const teamClassName = isMobile ? 'small align-middle' : 'align-middle';
  const statClassName = isMobile ? 'small align-middle text-center' : 'align-middle text-center'
  const statClassNameBold = `${statClassName} font-weight-semibold`;

  return <tr className={trClassName}>
    <td className={indexClassName}>{stats.ranking || index + 1}</td>
    <td className={teamClassName}>
      <Team team={stats.team} scheduleId={stats.scheduleId} groupId={stats.groupId} />
    </td>
    <SchemaStatsRow
      properties={properties}
      stats={stats}
      className={statClassName}
      classNameBold={statClassNameBold}
    />
  </tr>
}
